import { ChromeToolbarButton } from '../../ChromeActions'
import { comicPanelRound } from '../comicPanelTokens'

type Props = {
  angular: boolean
  pageTitle: string
  layoutLabel?: string
  onEdit?: () => void
}

/** 阅读器内未成图页：紧凑占位，避免展开空白分格骨架 */
export function ComicReaderEmptyPage({ angular, pageTitle, layoutLabel, onEdit }: Props) {
  return (
    <div
      className={[
        'flex min-h-[7.5rem] flex-col items-center justify-center gap-2 border border-dashed border-line/80',
        'bg-[color-mix(in_srgb,var(--surface-muted)_55%,transparent)] px-4 py-8 text-center',
        comicPanelRound(angular),
      ].join(' ')}
    >
      <p className="text-sm font-semibold text-ink">{pageTitle}</p>
      <p className="text-xs text-ink-soft">本页尚未有成图{layoutLabel ? ` · ${layoutLabel}` : ''}</p>
      {onEdit ? (
        <ChromeToolbarButton type="button" className="mt-1 text-xs" onClick={onEdit}>
          去编辑
        </ChromeToolbarButton>
      ) : null}
    </div>
  )
}
